import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "button__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    class: _normalizeClass(['button', 'btn', _ctx.btnClasses]),
    disabled: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _cache[0] || (_cache[0] = _createTextVNode("Button"))
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_BaseSpinner, {
            key: 0,
            show: "",
            small: ""
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "disabled"]))
}